import { motion, useScroll, useSpring } from 'framer-motion';

/**
 * Slim 2px progress line at the top of the viewport, growing from 0 → 100% as
 * the user scrolls the page. Uses Framer Motion's useScroll (returns a normalized
 * MotionValue) so we never attach a manual scroll listener — the browser's
 * compositor handles the transform on the GPU.
 *
 * The spring smooths the value so it feels natural rather than rubber-banded
 * with Lenis's smooth-scroll inertia.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 30,
    mass: 0.4,
    restDelta: 0.001,
  });

  return (
    <motion.div
      aria-hidden
      style={{ scaleX, transformOrigin: '0% 50%' }}
      className="fixed top-0 left-0 right-0 z-[200] h-[2px] bg-gradient-to-r from-white/70 via-white to-white/70 will-change-transform pointer-events-none"
    />
  );
}
